import Axios from './config';

class LeadApi {
    static getStages() {
        return Axios({
            method: 'GET',
            url: '/leads/get-stages'
        }).then(res => res.data);
    }
}

export default LeadApi;
